import React from 'react'
import './../styles/ImageItem.css'
import FileSaver from 'file-saver'

function ImageItem(props) {
  const { url, id, removeHandler } = props
  
  function startDownload() {
    FileSaver.saveAs(`https://cors-anywhere.herokuapp.com/${url}`, `${id}.jpg`);
  }

  return (
    <div className="image-item">
      <img src={url} alt={id}/>
      <div>
        <span className="download" onClick={startDownload}>Download</span>
        <span className="remove" onClick={(e) => removeHandler(e, id)}>Remove</span>
      </div>
    </div>
  )
}

export default ImageItem
